import React, { useEffect, useState } from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  XIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

export default function RafflePurchaseComplete(props) {
  //STATE
  const [donorEmail, setDonorEmail] = useState("");

  const {
    history,
    location: { pathname, state: locationState },
    campaignLogoUrl,
    campusName,
    chabadHouseName,
    homeUrl,
    sellerId,
    gregorianYear,
    hebrewYear,
  } = props;

  const chabadAtCampusDescription = campusName
    ? `Chabad at ${campusName}`
    : chabadHouseName;
  const raffleShareUrl = `${window.location.origin}${homeUrl}`;
  const raffleShareMessage = `Hi! \nI thought you might be interested in supporting Jewish life on campus by purchasing a ticket in the ${chabadAtCampusDescription} Grand Draw sweepstakes! Let’s keep the flame going strong!`;

  useEffect(() => {
    if (!locationState || !locationState.donorEmail) {
      const rafflePath = pathname.replace("/purchase-complete", "");
      history.replace(rafflePath);
    } else {
      setDonorEmail(locationState.donorEmail);
    }
  }, [locationState, history, pathname]);

  const shareWithEmail = (raffleShareUrl, chabadAtCampusDescription) => {
    const emailShareSubject = `Have you seen ${chabadAtCampusDescription}’s Grand Draw?`;
    const emailShareMessage =
      `Hi! ` +
      `\n\nI thought you might be interested in supporting Jewish life on campus by purchasing a ticket in the ${chabadAtCampusDescription} Grand Draw sweepstakes! Let’s keep the flame going strong! ${raffleShareUrl} ` +
      `\n\nOne ticket and a chance for you to win can help ${chabadAtCampusDescription} reach their fundraising goal! Spread the word!`;

    window.location.href = `mailto:?subject=${encodeURIComponent(
      emailShareSubject
    )}&body=${encodeURIComponent(emailShareMessage)}`;
  };

  const shareWithSms = async (raffleShareUrl, chabadAtCampusDescription) => {
    const smsShareMessage = `Hi! \nI thought you might be interested in supporting Jewish life on campus by purchasing a ticket in the ${chabadAtCampusDescription} Grand Draw sweepstakes! Let’s keep the flame going strong! ${raffleShareUrl}`;
    window.location.href = `sms:?&body=${encodeURIComponent(smsShareMessage)}`;
  };

  return (
    <div
      style={{
        background:
          "linear-gradient(180deg,rgb(4.12, 164.69, 136.01) 6.5%,rgb(29.8, 198.69, 168.82) 64%)",
        paddingTop: 48,
        minHeight: "100vh",
      }}
    >
      <div className="fs-20 fw-900 text-center uppercase-text header-title">
        {!!sellerId ? <p>{chabadHouseName}</p> : <p>Chabad on Campus</p>}
        <p className="bh">ב״ה</p>
      </div>
      <div className="header-logo">
        <a href="/">
          <img alt="bckg" src={campaignLogoUrl} />
        </a>
        <p
          className="fs-50 fw-900 light-text mt-8 mb-72"
          style={{ textShadow: "0 0 4px rgba(0, 0, 0, 0.25)" }}
        >
          {`${gregorianYear}/${hebrewYear}`}
        </p>
      </div>
      <div className="ml-16 mr-16">
        <p
          className="fs-100 fw-800 mb-16 light-text text-center uppercase-text"
          style={{ textShadow: "0 0 4px rgba(0, 0, 0, 0.25)" }}
        >
          Thank you
        </p>
        <p
          className="fs-50 fw-600 light-text text-center mb-32"
          style={{ textShadow: "0 0 4px rgba(0, 0, 0, 0.25)" }}
        >
          for your donation!
        </p>
        <p
          className="fs-18 fw-500 light-text text-center mb-120 line-height-double"
          style={{ textShadow: "0 0 4px rgba(0, 0, 0, 0.25)" }}
        >
          We have emailed a receipt to {donorEmail}
        </p>
      </div>
      <div>
        <p className="fs-24 fw-700 text-center mb-48 ml-16 mr-16 line-height-double">
          Now spread the word about the Grand Draw!
        </p>
        <div className="flex social-links" style={{ paddingBottom: 120 }}>
          <div
            className="flex flex-justify-center flex-align-center social-link-btn email-btn"
            onClick={() =>
              shareWithEmail(raffleShareUrl, chabadAtCampusDescription)
            }
          >
            <i className="material-icons mr-8">email</i>
            Share
          </div>
          <div
            className="flex flex-justify-center flex-align-center social-link-btn sms-btn"
            onClick={() =>
              shareWithSms(raffleShareUrl, chabadAtCampusDescription)
            }
          >
            <i className="material-icons mr-8">sms</i>
            Share
          </div>
          <FacebookShareButton
            quote={`${raffleShareMessage} ${raffleShareUrl}`} //FB share does not append URL to quote t/f appending manually here
            url={raffleShareUrl}
          >
            <div className="flex flex-justify-center flex-align-center social-link-btn facebook-btn">
              <FacebookIcon bgStyle={{ fill: "none" }} />
              Share
            </div>
          </FacebookShareButton>
          <TwitterShareButton title={raffleShareMessage} url={raffleShareUrl}>
            <div className="flex flex flex-justify-center flex-align-center social-link-btn twitter-btn">
              <XIcon bgStyle={{ fill: "none" }} />
              Share
            </div>
          </TwitterShareButton>
          <WhatsappShareButton title={raffleShareMessage} url={raffleShareUrl}>
            <div className="flex flex flex-justify-center flex-align-center social-link-btn whatsapp-btn">
              <WhatsappIcon />
              Share
            </div>
          </WhatsappShareButton>
        </div>
      </div>
    </div>
  );
}
